<template>
  <v-dialog persistent v-model="dialog" width="900" v-if="dialog" :key="dialog">
    <div class="modal-container">
      <div class="header-modal">
        <h3 v-html="title" />
        <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-card class="modal-content">
        <div class="scrollable-content">
          <slot />
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.v-dialog {
  border-radius: 24px !important;
  z-index: 9999 !important;
}

.header-modal {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.modal-container {
  width: 100%;
  display: flex;
  padding: 24px;
  background-color: #e9e8ed;
  align-items: flex-start;
  justify-content: center;
  border-radius: 20px;
  flex-direction: column;
}

.modal-content {
  width: 100%;
  display: flex;
  padding: 0;
  max-height: 70vh;
  overflow-y: auto;
  border-radius: 20px !important;
}

.scrollable-content {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
